const MY_DAY_VIEW_SLOT = {
    FREE_SLOT_TITLE: 'available',
    WORK_INTEGRATION: 'wi',
    IS_SYNC: 't',
}

const MY_DAY_VIEW = {
    CLIENT_AND_SERVER_TIME_DIFF_THRESHOLD: 60,
    TIME_ISSUE_FIX_ARTICLE_URL:
        'https://tribe.kalvium.community/t/synchronizing-time-with-internet-time-a-comprehensive-guide-for-all-operating-systems-2024',
}

const SESSION_CANCEL_REASON = [
    {
        value: 'Students are falling behind the planned progress',
    },
    {
        value: 'The assigned facilitator is on sick/planned leave',
    },
    {
        value: 'The facilitator was unprepared',
    },
    {
        value: 'The planned agenda cannot be facilitated due to technical/infra reasons',
    },
    {
        value: 'The University has declared a holiday',
    },
    {
        value: 'The session has a calendar conflict with another event',
    },
]

const UNTRACKED_COURSES = {
    wi: {
        title: 'WI',
        slug: 'wi',
        agendas: [
            { slug: 'tasks', title: 'Make progress on your assigned tasks' }
        ]
    },
    dojo: {
        title: 'Dojo',
        slug: 'dojo',
        agendas: [
            { slug: 'dojo_workout', title: 'Dojo Workout' },
            { slug: 'dojo_belttest', title: 'Dojo Belt Test' }
        ]
    },
    plus_ultra: {
        title: 'Plus Ultra',
        slug: 'plus_ultra',
        agendas: [
            { slug: 'wi_eligibility', title: 'Time to work on WI Eligibility markers' },
            { slug: 'acad_backlog', title: 'Academic Backlog' },
            { slug: 'konfident', title: 'Konfident Interviews' },
            { slug: 'communication_test', title: 'Communication skills test' }
        ]
    },
    event: {
        title: 'Event',
        slug: 'event',
        agendas: [
            { slug: 'kth', title: 'Kalvium Town Hall' },
            { slug: 'industry_talks', title: 'Industry Talks' },
            { slug: 'campus_leet', title: 'Campus Leet' }
        ]
    },
    bca: {
        title: 'BCA',
        slug: 'bca',
        agendas: [
            { slug: 'bca', title: 'Time for BCA coursework' }
        ]
    }
}

const PULSE_TYPES = {
    CHANGE_REQUEST_APPROVED: 'CHANGE_REQUEST_APPROVED',
    CHANGE_REQUEST_REJECTED: 'CHANGE_REQUEST_REJECTED',
}

export {
    MY_DAY_VIEW,
    MY_DAY_VIEW_SLOT,
    SESSION_CANCEL_REASON,
    UNTRACKED_COURSES,
    PULSE_TYPES,
}
